import React, { Component } from "react";
import Highcharts from "highcharts/highcharts.js";
import HighchartsReact from "highcharts-react-official";
import "./StackedBarChart.css"


const defaultOptions = {
    title: null,
    legend: {
        enabled: false
    },
    credits: {
        enabled: false
    },
    plotOptions: {
        bar: {
            dataLabels: {
                enabled: false,
                color: "#fff",
                formatter(){
                    return `$${Math.abs(this.y) > 999 ? `${((Math.abs(this.y)/1000).toFixed(1))}K` : this.y}`
                }
            },
        },
        series: {
            animation: false,
            groupPadding: 0.15,
            pointPadding: 1,
        },
    },
    tooltip: {
        borderRadius: 15,
        borderWidth: 1,
        borderColor: "#707070",
        backgroundColor: "#FFFFFF",
        padding: 17,
        shape: "square",
        style : {
            font: "Arial",
            fontSize: "14px",
            color: "#333333",
            lineHeight: 25,
            zIndex: 999,
        },
        formatter(){
            let response = `Occupation: <b>${this.key}</b><br/>`
            if(this.series.name === "Change 2023-2033" || this.series.name === "2023 jobs") {
                response += `${this.series.name} in a selected industry: <b>${this.y.toLocaleString("en-US")}</b>`
            }
            if(this.series.name === "Percent Growth") {
                response += `%Change (2023-2033): <b>${this.y.toLocaleString("en-US")}</b>`
                response += ` %`;
            }
            response += `<br/>`;
            return response
        }
    }
}

class StackedBarChart extends Component {
  	constructor(props) {
		super(props);
  	}

	render() {
        Highcharts.setOptions(this.props.containerId, {});
        let newDefaultOptions = {...defaultOptions}
        if (this.props.stacking !== null) {
            newDefaultOptions.plotOptions.series = {"stacking": this.props.stacking, pointWidth: 15, groupPadding: 0.15, animation: false}
        }
        return (
            <div id={this.props.containerId}>
                {this.props.remainingOptions ? <HighchartsReact
                    options = {{
                        ...newDefaultOptions,
                        ...this.props.remainingOptions,
                    }}
                    highcharts = { Highcharts }
                /> : <h1>...loading...</h1>}
            </div>
        )
	}
}


export default StackedBarChart;
